import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 斯洛伐克
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Všetky práva vyhradené',
    },
    auth: {
        login: 'Prihlásiť sa',
        username: 'Používateľské meno',
        username_placeholder: 'Zadajte používateľské meno',
        password: 'Heslo',
        password_placeholder: 'Zadajte heslo',
        code: 'Overovací kód',
        code_placeholder: 'Zadajte overovací kód',
        logout: 'Odhlásiť sa',
        logout_success: 'Úspešne ste sa odhlásili',
        day: 'deň',
        password_expiration: 'Platnosť hesla vypršala – je potrebné ho zmeniť',
        expire: 'Zostávajúce dni do vypršania platnosti hesla',
        conseils:
            'Musí obsahovať veľké písmená, malé písmená, číslice a špeciálne znaky ({msg}). Dĺžka hesla musí byť medzi 8 a 16 znakmi.',
        brand_Selection: 'Výber značky',
        unread_notices: 'Neprečítané oznámenia',
        new_cases: 'Nové prípady',
        unanswered_cases: 'Nezodpovedané prípady',
        overdue_cases: 'Po lehote splnenia',
    },
    button: {
        query: 'Dopyt',
        editing_position: 'Upraviť pozíciu',
        show_theme_editor: 'Zobraziť/skryť editor motívu',
        change_password: 'Zmeniť heslo',
        old_password: 'Staré heslo',
        new_password: 'Nové heslo',
        confirm_password: 'Potvrďte heslo',
        button: 'Tlačidlo',
        about: 'O nás',
        back: 'Späť',
        go: 'OK',
        home: 'Domov',
        confirm: 'Potvrdiť',
        modify: 'Upraviť',
        edit: 'Editovať',
        new: 'Nový',
        cancel: 'Zrušiť',
        close: 'Zatvoriť',
        search: 'Hľadať',
        reset: 'Obnoviť',
        delete: 'Odstrániť',
        add: 'Pridať',
        collapse: 'Zbaliť',
        expand: 'Rozbaliť',
        download_template: 'Stiahnuť šablónu',
        batch_import: 'Hromadný import',
        import: 'Importovať',
        export: 'Exportovať',
        export_fail: 'Import zlyhal',
        detailed: 'Podrobný',
        details: 'Podrobnosti',
        download: 'Stiahnuť',
        toView: 'Zobraziť',
        toViews: 'Zobraziť obrázky',
        uploadAttachments: 'Nahrať prílohy',
        selectFile: 'Vyberte súbor',
        fillingInstructions: 'Pokyny na vyplnenie',
        release: 'Zverejniť',
        release_recall: 'Stiahnuť zverejnenie',
        save: 'Uložiť',
        send: 'Odoslať',
        tips: 'Tipy',
        send_back: 'Vrátiť späť',
        examine: 'Skontrolovať',
        void: 'Zrušiť',
        more: 'Viac',
        refresh: 'Obnoviť',
        selects: 'Vybrať',
        serial_number: 'Sériové číslo',
        upload_progress: 'Priebeh nahrávania',
        invalid: 'Neplatné',
        daily_record: 'Denný záznam',
        operation_type: 'Typ operácie',
        field_name: 'Názov poľa',
        edit_role: 'Upraviť rolu',
        user_role: 'Vyberte rolu',
        assignment_role: 'Rola',
        post: 'Pozícia',
        sending: 'Odosielanie...',
        reset_password: 'Obnoviť heslo',
        display_or_not: 'Zobraziť alebo nie',
        document: 'Dokument',
        specificTemplates: 'Špecifické šablóny',
        transferOrder: 'Presunúť objednávku',
        forwarding: 'Postúpiť',
        one_click_notification: 'Notifikácia jedným kliknutím',
        english_export: 'Exportovať v angličtine',
        oneclick_download: 'Jednoklikové stiahnutie',
        passwordmsga:
            'Musí obsahovať veľké písmená, malé písmená, číslice a špeciálne znaky (@\\$!_~\\&*)',
        passwordmsgb: 'Dĺžka hesla musí byť medzi 8 a 16 znakmi',
        passwordmsgc: 'Nesmie byť rovnaké ako ktorékoľvek z posledných šiestich hesiel',
        export_file_list: 'Zoznam exportovaných súborov',
        personal_center: 'Osobné centrum',
        upload_list: 'Zoznam nahratí',
        clear_completed: 'Vymazať dokončené',
    },
    radio: {
        enabled: 'Povolené',
        disabled: 'Zakázané',
        catalogue: 'Katalóg',
        individual: 'Individuálne',
        all: 'Všetky',
        yes: 'Áno',
        no: 'Nie',
    },
    dropdown: {
        close_others: 'Zatvoriť ostatné',
        close_right: 'Zatvoriť vpravo',
        close_left: 'Zatvoriť vľavo',
    },
    table: {
        action: 'Akcia',
        explain: 'Vysvetlenie',
        fileName: 'Názov súboru',
        size: 'Veľkosť (MB)',
        uploader: 'Nahral(a)',
        uploadTime: 'Dátum nahratia',
        system: 'Systém',
        caption: 'Popis',
        categorization: 'Kategorizácia',
        link: 'Odkaz',
        forwarding_time: 'Dátum postúpenia',
        forwarder: 'Postúpil(a)',
        send_to: 'Odoslať komu',
        mode: 'Režim',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `Strana ${named('number')}`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `Celkom ${named('number')} záznamov`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) =>
            `Celkom ${named('number')} vozidiel`,
    },
    confirm: {
        confirm_deletion: 'Potvrdiť odstránenie?',
        confirm_void: 'Potvrdiť zrušenie?',
        confirm_release: 'Potvrdiť zverejnenie?',
        ack: 'Potvrdiť',
        cancel: 'Zrušiť',
        non_records: 'Vyberte aspoň jeden záznam',
    },
    request: {
        failed_placeholder: 'Požiadavka zlyhala – chyba servera',
        success_placeholder: 'Požiadavka bola úspešná',
        auth: {
            login_success: 'Prihlásenie bolo úspešné',
        },
        error: {
            '404': 'Cesta požiadavky nebola nájdená',
            '403': 'Nedostatočné oprávnenia',
        },
    },
    page: {
        global: {
            page_search: 'Hľadať na stránke',
        },
        error: {
            not_found: 'Stránka nenájdená',
            not_found_des: 'Nič tu nie je',
            auth_failed: 'Nedostatočné oprávnenia',
            auth_failed_des: 'Táto stránka je zakázaná',
            file_format_error: 'Neplatný formát súboru!',
            preview_failed: 'Náhľad sa nepodaril! Súbor je poškodený!',
        },
        homepage: {
            homepage: homepage.homepage.skSK,
        },
        system: {
            menu: system.menu.skSK,
            dict: system.dict.skSK,
            dept: system.dept.skSK,
            role: system.role.skSK,
            user: system.user.skSK,
        },
        info: {
            announcement: Info.announcement.announcement.skSK,
            document: Info.document.document.skSK,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.skSK,
                recallActivity: tech.quality.recallActivity.skSK,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.skSK,
            },
            management: {
                inquiryOd: tech.management.inquiry.skSK,
                permission: tech.management.permission.skSK,
                onSiteSupportHq: tech.management.onSiteSupport.skSK,
                progHistoryHq: tech.management.progHistory.skSK,
                salesRecordHq: tech.management.salesRecord.skSK,
                vehicleInfoHq: tech.management.vehicleInfo.skSK,
                claimHq: tech.management.claim.skSK,
                filterHq: tech.management.filter.skSK,
                newCarlssue: tech.management.newCarIssue.skSK,
                newCarDefinition: tech.management.newCarDefinition.skSK,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.skSK,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.skSK,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.skSK,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.skSK,
        },
        statistics: statistics.inquiryStatistics.skSK,
        systemClassifyA: statistics.systemClassifyA.skSK,
        systemClassifyB: statistics.systemClassifyB.skSK,
        engineerStatistics: statistics.engineerStatistics.skSK,
        defectivePart: statistics.defectivePart.skSK,
        replyInquiryStatistics: statistics.replyInquiryStatistics.skSK,
        passRateStatistics: statistics.passRateStatistics.skSK,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.skSK,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.skSK,
        customsClearance135Rate: statistics.customsClearance135Rate.skSK,
        accumulatedClosureRate: statistics.accumulatedClosureRate.skSK,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.skSK,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.skSK,
    },
    validation: {
        common: {
            required: 'Toto pole je povinné',
            numeric: 'Musí byť celé číslo',
            decimal: 'Musí byť číslo',
            positive_interger: 'Musí byť kladné celé číslo',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Maximálne ${named('number')} číslic`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Nesmie presiahnuť ${named('number')} znakov`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Prekročený maximálny limit znakov (${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Musí mať aspoň ${named('number')} znakov`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Musí mať presne ${named('number')} znakov`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Nemôže byť väčšie ako ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Nemôže byť menšie ako ${named('number')}`,
            up_to_2_decimal_places: 'Maximálne 2 desatinné miesta',
            retain_up: 'Maximálne 10 číslic pred desatinnou čiarkou a 2 za ňou',
            retain_ups: 'Maximálne 11 číslic pred desatinnou čiarkou a 4 za ňou',
            input_number: 'Zadajte iba arabské číslice',
            only_number_a: 'Povolené sú len písmená alebo číslice',
            translate: 'Povolené sú len písmená',
            positive_integer: 'Vyplňte aspoň jedno pole',
            at_least_one: 'Vyplňte aspoň jedno',
        },
        tip: {
            incomplete_information: 'Neúplné informácie',
        },
    },
    import: {
        template_file: 'Súbor šablóny',
        browse: 'Prehliadať',
        download_template: 'Stiahnuť šablónu',
        no_file_selected: 'Nie je vybraný žiadny súbor',
        incorrect_file_type: 'Nesprávny typ súboru',
        exceed: 'Prekročený limit',
        upload_success: 'Nahratie bolo úspešné',
        upload_fail: 'Nahratie zlyhalo',
        again_upload:
            'Je možné nahrávať iba obrázky vo formátoch jpg, png, bmp alebo gif. Skúste to znova.',
        attachmentUpload: 'Nahrať prílohy',
        otherAttachmentUpload: 'Nahrať ďalšie prílohy',
        supportedFormats: 'Podporované formáty',
        preview: 'Náhľad',
    },
    export: {
        noDataToExport: 'Žiadne údaje na export',
    },
    select: {
        all: 'Všetky',
    },
    checkbox: {
        select_all: 'Vybrať všetko',
    },
    dialog: {
        error_message: 'Chybová správa',
        one_year: 'Je možné exportovať maximálne jeden rok údajov naraz',
    },
    ymd: {
        year: 'rok',
        month: 'mesiac',
        day: 'deň',
        week: 'týždeň',
        january: 'Január',
        february: 'Február',
        march: 'Marec',
        april: 'Apríl',
        may: 'Máj',
        june: 'Jún',
        july: 'Júl',
        august: 'August',
        september: 'September',
        october: 'Október',
        november: 'November',
        december: 'December',
    },
};
